import React from 'react';
import { Box, Container, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <Container maxW="container.lg" py={10}>
      <VStack spacing={6} align="stretch">
        <Heading as="h1" size="2xl" mb={6}>Privacy Policy</Heading>

        <Box>
          <Heading as="h2" size="lg" mb={4}>1. Information We Collect</Heading>
          <Text mb={4}>
            We collect information that you provide directly to us, including when you:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Create an account</Text>
            <Text as="li">Write journal entries</Text>
            <Text as="li">Use our AI features</Text>
            <Text as="li">Contact us</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>2. How We Use Your Information</Heading>
          <Text mb={4}>
            We use the information we collect to:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Provide and maintain our services</Text>
            <Text as="li">Process your journal entries</Text>
            <Text as="li">Improve our AI features</Text>
            <Text as="li">Communicate with you</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>3. Data Security</Heading>
          <Text mb={4}>
            We take the security of your data seriously. All journal entries are encrypted using industry-standard encryption methods. We implement appropriate technical and organizational measures to protect your personal information.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>4. Data Sharing</Heading>
          <Text mb={4}>
            We do not sell your personal information. We may share your information with:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Service providers who assist in operating our services</Text>
            <Text as="li">Law enforcement when required by law</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>5. Your Rights</Heading>
          <Text mb={4}>
            You have the right to:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Access your personal information</Text>
            <Text as="li">Correct inaccurate information</Text>
            <Text as="li">Request deletion of your information</Text>
            <Text as="li">Export your data</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>6. Changes to This Policy</Heading>
          <Text mb={4}>
            We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the effective date.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>7. Contact Us</Heading>
          <Text mb={4}>
            If you have any questions about this privacy policy, please contact us through <Link as={RouterLink} to="/contact" color="blue.500">our contact form</Link>.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default PrivacyPolicyPage; 